import { useEffect } from "react";
import { frontDB } from "../../../../frontDB";
import { useWorkOrders } from "../../useWorkOrders";
import ComponentSearch from "./Components/ComponentSearch/ComponentSearch";
import JobSearch from "./Components/JobSearch/JobSearch";
import styles from "./WorkOrdersHeader.module.css";
import { useWorkOrdersHeader } from "./useWorkOrdersHeader";
import CloseIcon from "@rsuite/icons/Close";
import {
  InputPicker,
  Input,
  Radio,
  RadioGroup,
  InputGroup,
  DateRangePicker,
  Whisper,
  Popover,
  Dropdown,
  IconButton,
} from "rsuite";
import { showActive } from "../../../../helperFunctions";
import { FiMenu } from "react-icons/fi";

function WorkOrdersHeader() {
  let { locations, responsibles, location } = frontDB();
  let { workOrdersArrayLength } = useWorkOrders();

  let {
    filter,
    locationHandler,
    statusHandler,
    componentHandler,
    jobHandler,
    periodRangeHandler,
    period,
    woPrefix,
    responsibleHandler,
    plannedTypeHandler,
    plannedType,
    setSelectedLocation,
    searchClearHandler,
    searchByNumberHandler,
    searchNumber,
    onExport,
    generatingRL,
  } = useWorkOrdersHeader();

  useEffect(() => {
    setSelectedLocation();
  }, [location]);

  // Only active

  locations = showActive(locations);
  responsibles = showActive(responsibles);

  let locationOptions = [
    { label: "All vessels", value: "*" },
    ...locations
      .filter((location) => location.name != "Office")
      .map((item) => ({ label: item.name, value: item._id })),
  ];

  let statusOptions = [
    { label: "All statuses", value: "*" },
    ...["Planned", "Performed", "Cancelled", "Filled"].map((item) => ({
      label: item,
      value: item.toLowerCase(),
    })),
  ];

  let responsibleOptions = [
    { label: "All responsibles", value: "*" },
    ...responsibles.map((item) => ({ label: item.name, value: item._id })),
  ];

  const startOfUTCDate = (date) => {
    return new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0,
        0,
        0,
      ),
    );
  };

  const endOfUTCDate = (date) => {
    return new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        23,
        59,
        59,
        999,
      ),
    );
  };

  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setUTCDate(now.getUTCDate() + 1);
  const tomorrowEnd = endOfUTCDate(tomorrow);
  const today = new Date(now);

  const todayEnd = endOfUTCDate(today);
  const start7Days = new Date(now);
  start7Days.setUTCDate(now.getUTCDate() - 7);

  const start14Days = new Date(now);
  start14Days.setUTCDate(now.getUTCDate() - 14);

  const start1Month = new Date(now);
  start1Month.setUTCMonth(now.getUTCMonth() - 1);

  const start3Month = new Date(now);
  start3Month.setUTCMonth(now.getUTCMonth() - 3);

  const start6Month = new Date(now);
  start6Month.setUTCMonth(now.getUTCMonth() - 6);

  const start12Month = new Date(now);
  start12Month.setUTCMonth(now.getUTCMonth() - 12);

  const start24Month = new Date(now);
  start24Month.setUTCMonth(now.getUTCMonth() - 24);

  const predefinedRanges = /** @type {any} */ ([
    {
      label: "7 days",
      value: [startOfUTCDate(start7Days), todayEnd],
      placement: "left",
    },
    {
      label: "14 days",
      value: [startOfUTCDate(start14Days), todayEnd],
      placement: "left",
    },
    {
      label: "1 month",
      value: [startOfUTCDate(start1Month), todayEnd],
      placement: "left",
    },
    {
      label: "3 month",
      value: [startOfUTCDate(start3Month), todayEnd],
      placement: "left",
    },
    {
      label: "6 month",
      value: [startOfUTCDate(start6Month), todayEnd],
      placement: "left",
    },
    {
      label: "12 month",
      value: [startOfUTCDate(start12Month), todayEnd],
      placement: "left",
    },
    {
      label: "24 month",
      value: [startOfUTCDate(start24Month), todayEnd],
      placement: "left",
    },
  ]);

  let plannedTypeFilter = (
    <>
      <RadioGroup
        value={plannedType}
        onChange={plannedTypeHandler}
        name="radioList"
        inline
      >
        <Radio value="all">All</Radio> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Radio value="overDue">OverDue</Radio> &nbsp;&nbsp;&nbsp;&nbsp;
        <Radio value="postponed">Postponed</Radio>
      </RadioGroup>
    </>
  );

  const exportMenu = (
    <div className={styles.button_container}>
      <Dropdown
        placement="bottomEnd"
        renderToggle={(props, ref) => (
          <IconButton
            {...props}
            ref={ref}
            icon={<FiMenu style={{ height: 20, width: 30 }} />}
            appearance="subtle"
            style={{
              width: "auto",
              height: 35,
              marginLeft: 0,
              display: "flex",
              alignItems: "center",
              padding: "0 12px",
              opacity: generatingRL ? 0.5 : 1,
              pointerEvents: generatingRL ? "none" : "auto",
            }}
          />
        )}
      >
        <Dropdown.Item
          disabled={generatingRL}
          onClick={() => {
            onExport(workOrdersArrayLength);
          }}
        >
          <div style={{ marginLeft: 15, width: 200 }}>
            Export Work Orders list
          </div>
        </Dropdown.Item>
      </Dropdown>
    </div>
  );

  //! Render
  return (
    <>
      <div className={styles.workorders_header}>
        <div className={styles.workorders_header_title}>
          Work orders
          {woPrefix && (
            <div className={styles.search_by_number}>
              <Whisper
                placement="top"
                trigger="hover"
                delay={500}
                speaker={<Popover>Enter WO number</Popover>}
              >
                <div className={styles.search_prefix}>
                  {woPrefix && <div>{woPrefix}-</div>}
                  <InputGroup inside>
                    <Input
                      className={styles.search_input}
                      value={searchNumber}
                      onChange={searchByNumberHandler}
                      id="number"
                      placeholder="Search by #"
                    />

                    {searchNumber && searchNumber.length > 0 && (
                      <InputGroup.Button
                        id="company"
                        onClick={() => searchClearHandler("number")}
                      >
                        <CloseIcon />
                      </InputGroup.Button>
                    )}
                  </InputGroup>
                </div>
              </Whisper>
            </div>
          )}
        </div>

        <div className={styles.workorders_header_content}>
          <div className={styles.workorders_header_options}>
            <InputPicker
              value={filter?.locationId}
              onChange={locationHandler}
              cleanable={false}
              placeholder="Select location"
              data={locationOptions}
              style={{ width: 160 }}
            />
            <div className={styles.workorders_component_search}>
              <ComponentSearch
                onComponentChange={componentHandler}
                locationId={filter?.locationId}
              />
            </div>
            <JobSearch
              style={{ width: "200px" }}
              onJobChange={jobHandler}
              defaultJobId={filter?.jobId}
              locationId={filter?.locationId}
            />

            <InputPicker
              value={filter?.responsibleId}
              onChange={responsibleHandler}
              cleanable={false}
              placeholder="Select responsible"
              data={responsibleOptions}
              style={{ width: 160 }}
            />

            <DateRangePicker
              isoWeek
              ranges={predefinedRanges}
              value={[new Date(period?.from), new Date(period?.to)]}
              onChange={periodRangeHandler}
              cleanable={false}
              format="dd/MM/yyyy"
              placeholder="Select period"
              style={{ width: 320 }}
            />

            <InputPicker
              value={filter?.status}
              onChange={statusHandler}
              cleanable={false}
              placeholder="Select status"
              data={statusOptions}
              style={{ width: 200 }}
            />

            {filter?.status == "planned" && plannedTypeFilter}
          </div>

          {exportMenu}
        </div>
      </div>
    </>
  );
}

export default WorkOrdersHeader;

//c Допоміжні
